import s from"react";import m from"antd/es/image";var w=({src:r,width:t,height:o,previewSrc:e,style:p={},alt:i=""})=>s.createElement(m,{width:t,height:o,src:r,style:p,...e?{preview:{src:e}}:{preview:!1},alt:i});export{w as default};
//# sourceMappingURL=index.js.map
